
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS, SERVICES_DATA } from '../../constants';
import { CORE_NODE_CATEGORIES, NODE_TYPES } from './constants';

interface FlowsLibraryProps {
  language: Language;
  isLibraryOpen: boolean;
  libraryTab: 'nodes' | 'services';
  onSetLibraryTab: (tab: 'nodes' | 'services') => void;
  onAddNode: (def: any, isService: boolean) => void;
}

const FlowsLibrary: React.FC<FlowsLibraryProps> = ({ 
  language, isLibraryOpen, libraryTab, onSetLibraryTab, onAddNode 
}) => {
  const t = TRANSLATIONS[language];
  const isRtl = language === 'ar';

  return (
    <aside className={`absolute lg:static inset-y-0 ${isRtl ? 'right-0' : 'left-0'} w-72 bg-[#15151a] border-r border-white/5 z-30 transition-transform duration-300 flex flex-col ${isLibraryOpen ? 'translate-x-0' : '-translate-x-full'}`}>
       <div className="p-2 grid grid-cols-2 gap-1 border-b border-white/5">
          <button onClick={() => onSetLibraryTab('nodes')} className={`py-2 text-[10px] font-black uppercase tracking-wider rounded-lg transition-all ${libraryTab === 'nodes' ? 'bg-white/10 text-white' : 'text-slate-500 hover:bg-white/5'}`}>{t.nodeLibrary}</button>
          <button onClick={() => onSetLibraryTab('services')} className={`py-2 text-[10px] font-black uppercase tracking-wider rounded-lg transition-all ${libraryTab === 'services' ? 'bg-white/10 text-white' : 'text-slate-500 hover:bg-white/5'}`}>{t.servicesLibrary}</button>
       </div>
       <div className="flex-1 overflow-y-auto p-4 space-y-6 custom-scrollbar">
          {libraryTab === 'nodes' ? Object.entries(CORE_NODE_CATEGORIES).map(([catKey, cat]) => (
             <div key={catKey}>
                <h4 className={`text-[10px] font-bold text-${cat.color}-500 mb-3 uppercase tracking-widest flex items-center gap-2`}><i className={`fas ${cat.icon}`}></i> {cat.label}</h4>
                <div className="space-y-2">
                   {Object.entries(NODE_TYPES).filter(([_, n]) => n.cat === catKey).map(([key, def]) => (
                      <div key={key} onClick={() => onAddNode(def, false)} className="group flex items-center gap-3 p-3 rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 hover:border-white/20 cursor-pointer transition-all active:scale-95">
                         <div className={`w-8 h-8 rounded-lg bg-${cat.color}-500/20 flex items-center justify-center text-${cat.color}-400 group-hover:text-white transition-colors`}><i className={`fas ${cat.icon} text-xs`}></i></div>
                         <span className="text-xs font-bold text-slate-300 group-hover:text-white">{def.label}</span>
                         <i className={`fas fa-plus text-[10px] ml-auto opacity-0 group-hover:opacity-100 transition-opacity text-${cat.color}-500`}></i>
                      </div>
                   ))}
                </div>
             </div>
          )) : (
             <div className="space-y-2">
                {SERVICES_DATA.map(service => (
                   <div key={service.id} onClick={() => onAddNode(service, true)} className="group flex items-center gap-3 p-3 rounded-xl bg-white/5 hover:bg-white/10 border border-white/5 hover:border-white/20 cursor-pointer transition-all active:scale-95">
                      <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${service.color} flex items-center justify-center text-white shadow-sm`}><i className={`fas ${service.icon} text-xs`}></i></div>
                      <div className="flex-1 min-w-0"><h4 className="text-xs font-bold text-white truncate">{service.title}</h4><p className="text-[9px] text-slate-500 truncate">{service.category}</p></div>
                      <i className="fas fa-plus text-[10px] opacity-0 group-hover:opacity-100 transition-opacity text-emerald-500"></i>
                   </div>
                ))}
             </div>
          )}
       </div>
    </aside>
  );
};
export default FlowsLibrary;
